import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

require("./TagLink.scss");

const TagLink = ({ link, children }) => (
    <div className="tag-link">
        <Link to={link}>{children}</Link>
    </div>
);

TagLink.propTypes = {
    link: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired
};

export default TagLink;



// WEBPACK FOOTER //
// ./modules/Common/components/TagLink.js